/**
 * Libs
 */
import styled, { css } from 'styled-components';

/**
 * Constants
 */
import { speed } from 'src/ui/common/config/animations';

export const StyledFaqCategoriesMenu = styled.div`
  position: sticky;
  top: 96px;
  min-width: 350px;
  margin-right: 56px;
  
  h3 {
    margin-bottom: 32px;
  }
  
  ul {
    list-style-type: none;
  }
`;

export const StyledFaqCategoryLink = styled.a<{
    active: boolean;
}>`
  display: block;
  padding: 15px 10px;
  border-radius: 5px;
  transition: background-color ${speed.content} ease-in-out;
  
  ${({ active }) => active && css`
    background-color: ${({ theme }) => theme.colors.gs500};
  `}

  &:hover {
    background-color: ${({ theme }) => theme.colors.gs500};
  }
`;
